import React from 'react';
import { ITeenReferralFields } from '../../../types/contentful';
import { usePageDataContext } from '../../context/PageData';

interface Props extends ITeenReferralFields {
  sysId?: string;
}

export function TeenReferral({ enabled = true, sysId }: Props) {
  const { teenReferralData } = usePageDataContext();

  // Hide if not enabled or no teen name
  if (!enabled || !teenReferralData?.name) {
    return null;
  }

  const { name, message, features } = teenReferralData;

  return (
    <div
      className="block-container"
      data-eltype="teen-referral"
      data-blockid={sysId}
      id={sysId}
      data-testid="teenReferral"
    >
      <div className="mx-md w-full gap-2 rounded-md bg-screen-surface p-6 desktop:w-8/12">
        {/* Testimonial Header */}
        {message && (
          <>
            <div className="w-full">
              <p className="typography-title-3 mb-2">&ldquo;{message}&rdquo;</p>
              <p className="typography-body-1 font-light">-{name}</p>
            </div>
            <div className="mb-4 w-full"></div>
          </>
        )}
        {/* Features Section */}
        {features && features.length > 0 && (
          <>
            <div className="column w-full">
              <p className="typography-body-1 mb-2 font-light">
                These are the features your child is most excited about.
              </p>
            </div>
            <div className="flex w-full flex-col gap-2">
              {features.map((feature, index) => (
                <TeenReferralFeature key={index} {...feature} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function TeenReferralFeature({
  badge_image,
  badge_copy
}: {
  badge_image: string;
  badge_copy: string;
}) {
  return (
    <div className="flex flex-col  rounded-[8px] bg-white">
      <div className="border-line-shadow-line flex items-center p-2 ">
        <img src={badge_image} alt={badge_copy} className="w-20" />
        {badge_copy && (
          <span className="typography-title-4 ml-4 font-normal">
            {badge_copy}
          </span>
        )}
      </div>
    </div>
  );
}
